document.addEventListener('DOMContentLoaded', function () {
    const swiperContainers = document.querySelectorAll('[data-ingredientes-swiper]');

    swiperContainers.forEach(function (container) {
        new Swiper(container, {
            slidesPerView: 1.05,
            spaceBetween: 16,
            freeMode: true,
            grabCursor: true,
            breakpoints: {
                768: {
                    slidesPerView: 3.2,
                    spaceBetween: 32,
                },
            },
        });
    });

    // Toggle para expandir/contrair descrição
    const toggleButtons = document.querySelectorAll('.ingredientes__card-toggle');
    toggleButtons.forEach(function (btn) {
        const description = btn.closest('.ingredientes__card-content').querySelector(
            '.ingredientes__card-description'
        );

        // Inicializa o estado correto com base no aria-expanded
        if (description) {
            if (btn.getAttribute('aria-expanded') === 'false') {
                description.style.display = 'none';
            } else {
                btn.closest('.ingredientes__card').classList.add('is-expanded');
            }
        }

        btn.addEventListener('click', function () {
            const expanded = btn.getAttribute('aria-expanded') === 'true';
            btn.setAttribute('aria-expanded', String(!expanded));
            if (description) {
                description.style.display = expanded ? 'none' : 'block';
            }
            btn.closest('.ingredientes__card').classList.toggle('is-expanded', !expanded);
        });
    });

    // Toggle por hover no card inteiro
    const cards = document.querySelectorAll('.ingredientes__card');
    cards.forEach(function (card) {
        card.addEventListener('mouseenter', function () {
            const btn = card.querySelector('.ingredientes__card-toggle');
            const description = card.querySelector('.ingredientes__card-description');
            if (btn && btn.getAttribute('aria-expanded') === 'false') {
                btn.setAttribute('aria-expanded', 'true');
                if (description) {
                    description.style.display = 'block';
                }
                card.classList.add('is-expanded');
            }
        });

        card.addEventListener('mouseleave', function () {
            const btn = card.querySelector('.ingredientes__card-toggle');
            const description = card.querySelector('.ingredientes__card-description');
            if (btn && btn.getAttribute('aria-expanded') === 'true') {
                btn.setAttribute('aria-expanded', 'false');
                if (description) {
                    description.style.display = 'none';
                }
                card.classList.remove('is-expanded');
            }
        });
    });
    // Toggle para Lista Completa (Accordion)
    const accordionTrigger = document.querySelector('.ingredients__accordion-trigger');
    if (accordionTrigger) {
        accordionTrigger.addEventListener('click', function () {
            const expanded = accordionTrigger.getAttribute('aria-expanded') === 'true';
            accordionTrigger.setAttribute('aria-expanded', String(!expanded));

            const content = accordionTrigger.nextElementSibling;
            if (content) {
                content.classList.toggle('is-expanded');
            }
        });
    }
});